import { render } from "./TenderInfo.vue?vue&type=template&id=42165ac7"
import script from "./TenderInfo.vue?vue&type=script&lang=js"
export * from "./TenderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__